const prefix = '/value-chain-maps/';

export const VC_AGENT_SESSION_LIST_TAG = `${prefix}{valueChainMapId}/agent-sessions`;
export const VC_AGENT_SESSION_RECORD_TAG = `${prefix}{valueChainMapId}/agent-sessions/{sessionId}`;
export const VC_DRAFT_STRUCTURE_TAG = `${prefix}{valueChainMapId}/agent-sessions/{sessionId}/draft-column/structure`;
export const VC_AGENT_SESSION_BOM_TAG = `${prefix}{valueChainMapId}/agent-sessions/{sessionId}/bom`;
export const VC_AGENT_SESSION_BOM_RECORD_TAG = `${prefix}{valueChainMapId}/agent-sessions/{sessionId}/bom/{bomId}`;
export const VC_AGENT_SESSION_BOM_ITEMS_TAG = `${prefix}{valueChainMapId}/agent-sessions/{sessionId}/bom/{bomId}/items`;
export const VC_AGENT_SESSION_BOM_LINE_ITEM_RECORD_TAG = `
${prefix}{valueChainMapId}/agent-sessions/{sessionId}/bom/{bomId}/items/{itemId}`;
export const VC_AGENT_SESSION_SUPPLIER_DISCOVERY_TAG = `
${prefix}{valueChainMapId}/agent-sessions/{sessionId}/supplier-discovery`;
export const VC_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_TAG = `
${prefix}{valueChainMapId}/agent-sessions/{sessionId}/supplier-discovery/{unitId}`;
export const VC_AGENT_SESSION_SUPPLIER_DISCOVERY_ITEMS_TAG = `
${prefix}{valueChainMapId}/agent-sessions/{sessionId}/supplier-discovery/{unitId}/items`;
export const VC_AGENT_SESSION_SUPPLIER_DISCOVERY_ITEM_RECORD_TAG = `
${prefix}{valueChainMapId}/agent-sessions/{sessionId}/supplier-discovery/{unitId}/items/{itemId}`;
export const VC_AGENT_MONITORING_SCHEDULES_TAG = `${prefix}{valueChainMapId}/agent-schedules`;
export const VC_AGENT_MONITORING_SCHEDULE_RUNS_TAG = `${prefix}{valueChainMapId}/agent-schedules/{scheduleId}/runs`;
export const VC_AGENT_MONITORING_SCHEDULE_EXECUTIONS_TAG = (
  `${prefix}{valueChainMapId}/agent-schedules/{scheduleId}/executions`
);
export const VC_AGENT_MONITORING_SESSION_EXECUTIONS_TAG = (
  `${prefix}{valueChainMapId}/agent-sessions/{sessionId}/executions`
);
export const VC_AGENT_MONITORING_RUN_FINDINGS_TAG = `${prefix}{valueChainMapId}/agent-runs/{runId}/findings`;
export const VC_AGENT_MONITORING_RESULTS_TAG = `${prefix}{valueChainMapId}/agent-monitoring-results`;
export default VC_AGENT_SESSION_LIST_TAG;
